export default __webpack_public_path__ + "static/media/property_415.a203d783.png";